<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Edit Segment
            </h2>
        </template>

        <segment-form
            :segment="segment"
            :verticals="verticals"
            :partners="partners"
            :domains="domains"
            :action="route('segments.update', segment.id)"
            button="Update"
        />
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import SegmentForm from './Form';

    export default {
        props: ['segment', 'verticals', 'partners', 'domains'],

        components: {
            AppLayout,
            SegmentForm,
        },
    }
</script>
